import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  addDesignations,
  updateDesignations,
} from '../../actions/userActions/designationAction'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import { HexColorPicker } from 'react-colorful';
import { getDesignationsLevel } from '../../actions/userActions/designationLevelAction'
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import Textarea from '../designSystem/TextArea'
import TextField from '../designSystem/TextField'
import { IconButton } from '@mui/material'
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import designationIcon from "../../assets/images/Icon=Designations.svg";
import closeModal from "../../assets/images/closeModal.svg";
import SingleSelect from '../designSystem/SingleSelect'
import { validateFields } from '../../utils/Validations'
import { Check, X } from 'lucide-react'
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import designationLevelIcon from "../../assets/images/designationLevelIcon.svg";
import AddNewForm from '../addNew/AddNewForm'
import AddNewDrawer from '../addNew/AddNewDrawer'
import Heading6Regular from '../designSystem/Heading6Regular'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import { t } from '../../locales/translate'

function AddDesignations({ onClose, editData, onSave }) {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const initialValues = {
    name: '',
    shortName: '',
    description: '',
    active: false,
    levelId: 0,
    color: '#002D72',
  }
  const [formValues, setFormValues] = useState(initialValues)
  const [formErrors, setFormErrors] = useState({})
  const currentPage = -1
  const itemsPerPage = 10
  const searchQuery = ''
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerItem , setDrawerItem] = useState(null);
  
  useEffect(() => {
    dispatch(getDesignationsLevel(currentPage, itemsPerPage, searchQuery))
  }, [dispatch, currentPage, itemsPerPage, searchQuery])
  useEffect(() => {
  if (editData) {
    setFormValues({
      ...editData,
      color: editData.colorString || editData.color || "#002D72",
    });
  }
}, [editData]);
 const handleSave = async (e) => {
  e.preventDefault();
  const errors = validateFields(formValues, 'designation');
  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  const requestBody = {
    id: formValues.id || 0,
    name: formValues.name,
    shortName: formValues.shortName,
    description: formValues.description,
    active: formValues.active,
    levelId: formValues.levelId,
    color: formValues.color || '#002D72'
  };
  if (editData) {
    await dispatch(updateDesignations(requestBody));
  } else {
    await dispatch(addDesignations(requestBody));
  }
  await onSave(formValues);
};

  const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
      setDrawerOpen(true);
    };

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;
  
  if (name === 'active') {
    setFormValues({ ...formValues, active: checked });
  } else {
    setFormValues({ ...formValues, [name]: value });
  }
};
  const designationLevels = useSelector(
    (state) => state.designationLevels_reducer.designationLevels,
  )
  const permissions = JSON.parse(localStorage.getItem('permissionsList'));
  const handleGoBack = () => {
    history.goBack();
  };
  const handleColorChange = (color) => {
  setFormValues({ ...formValues, color: color });
};
const validateColor = (color) => {
  return /^#[0-9A-F]{6}$/i.test(color) ? color : "#ffffff";
};
  const handleSelectChange = (event) => {
    setFormValues({
      ...formValues,
      levelId: event.value
    })
  }
  const getOptions = () => {

    return (
      designationLevels &&
      designationLevels !== "isLoading" &&
      designationLevels.length !== 0 && designationLevels?.result
        .filter((level) => level.active === true)
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((designationLevel) => ({
          value: designationLevel.id,
          label: designationLevel.name,
          // secondaryLabel: designationLevels.id
        }))
    ) || [];
  };
  return (
    <>
      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container">
          <div className="dynamicmodal-header ">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={designationIcon} alt="designationIcon" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Designation" : `${t("addDesignation")}`}
                </h2>
                <p className="modaldescription">
                  {t("addDesignationTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>

          </div>
          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body" style={{ paddingTop: '20px', maxHeight: 'calc(80vh - 200px)',overflowY: 'auto', overflowX: 'hidden', paddingRight: '8px' }}>
              <div className='row'>
                <div className='col-6'>
                  <TextField
                    name="name"
                    label={`${t("name")} *`}
                    type='text'
                    value={formValues.name}
                    onChange={handleChange}
                    placeholder={t("name")}
                    error={formErrors.name}
                  />
                </div>
                <div className='col-6'>
                  <TextField
                    name="shortName"
                    label={`${t("shortName")} *`}
                    type='text'
                    value={formValues.shortName}
                    onChange={handleChange}
                    placeholder={t("shortName")}
                    error={formErrors.shortName}
                  /></div>
              </div>

              <SingleSelect
                label={`${t("designationLevel")} *`}
                isSearchable
                secondaryLabel
                error={formErrors.levelId}
                iconEnd
                onChange={handleSelectChange}
                value={formValues.levelId}
                placeholder={t("designationLevel")}
                options={(designationLevels &&
                  designationLevels !== "isLoading" &&
                  designationLevels.length !== 0 && designationLevels?.result &&
                  designationLevels?.result?.length !== 0)
                  && getOptions()}
                  configKey={"designationLevel"}
                  onAddNewClick={() => handleAddNew("designationLevel")}
              />
              <Textarea
                name="description"
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.description}
                onChange={handleChange}
                error={formErrors.description} 
              />
<div className="col-md-12 mt-3">
  <label className="form-control-label">{`${t("color")} *`}</label>
  <HexColorPicker
    color={validateColor(formValues.color)}
    onChange={handleColorChange}
  />
  {formErrors.color && <div className='error-multi-select-container mt-2'>{formErrors.color}</div>}
</div>
              <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div style={{ padding: '2px' }}>
                    <p className="button-text">{t("active")}</p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="dynamicmodal-footer">
             <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
        </div>
      </div>
        <AddNewDrawer
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                 title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
                subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
                icon={drawerItem  === "designationLevel" ? <img src={designationLevelIcon} alt={drawerItem } /> : null}
                extraInfo={
                    <>
                      <Heading6Regular
                      text={`Level Order: ${designationLevels !== "isLoading" && designationLevels.totalCount + 1}`}
                      color="#1E293B"
                      />
                       <BodySmallMedium
                        text={"Lower numbers indicate higher levels in the hierarchy."}
                        color="#1E293B"
                        />
                    </>
                  }
              >
                {drawerItem  && (
                 <AddNewForm
                    itemName={drawerItem }
                    onClose={() => setDrawerOpen(false)}
                    onSave={(newData) => {
                      if (drawerItem  === "designationLevel") {
                        dispatch(getDesignationsLevel(currentPage, itemsPerPage, searchQuery)).then(() => {
                          setFormValues((prev) => ({
                            ...prev,
                            levelId: newData.id,
                            label: newData.name
                          }));
                        });
                      }
                    }}
                  />
      
                )}
      </AddNewDrawer>
    </>
  )
}

export default AddDesignations
